module.exports = __webpack_public_path__ + "svg/sagittarius.svg?1a28e6f42bb045dff1f225368dddc5a6";